/*
 *###############################################################################
 *Module Name                   : CashBookPOSTrading.js                         #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               :  W M Shanika Chamodi                          #
 *Date                          :  Friday, December 12th 2022, 1:16:56 pm       #
 *Copyright © 2022 myPOS Software Solution (pvt Ltd.)                           #
 *###############################################################################
 */
// import React, { useState, useEffect } from "react"
// import { Row, Col } from "reactstrap"
// import DPTextBoxforgrid from "../../../framework/components/DPTextBoxforgrid"
// import ReactPaginate from "react-paginate"

// const CashBookPOSTrading = React.memo(({ DataRow, Disabled, TotalPOSTrandingValue, handleClear, PayModeData }) => {

//   const [postsPerPage] = useState(2)
//   const [currentPage, setCurrentPage] = useState(1)

//   const [detPostsPerPage] = useState(10);
//   const [detCurrentPage, setDetCurrentPage] = useState(1);

//   const [placeholder, setPlaceholder] = useState("Search By POS ID")
//   const [SearchByPosId, setSearchByPosId] = useState(true)
//   const [SearchByBank, setSearchByBank] = useState(true)
//   const [SearchByMode, setSearchByMode] = useState(true)
//   const [searchElement, setElement] = useState("")
//   const [searchString, setSearchString] = useState("")
//   const [uniqueTotal, setUniqueTotal] = useState(null);

//   useEffect(() => {
//     const uniqueTotals = new Set(PayModeData.map(item => item.TOTAL));
//     const firstUniqueTotal = uniqueTotals.values().next().value;
//     setUniqueTotal(firstUniqueTotal);
//   }, [PayModeData]);

//   useEffect(() => {
//     setSearchString("")
//     setElement("INVPAY_STATION")
//     setPlaceholder("Search By POS ID")
//     setSearchByPosId(true)
//     setCurrentPage(1)
//     setDetCurrentPage(1)
//   }, [handleClear])

//   const handlePageClick = (event) => {
//     setCurrentPage(event.selected + 1);

//     console.log("Page clicked:", event.selected + 1);
//   };

//   const handleDetPageClick = (event) => {
//     setDetCurrentPage(event.selected + 1);
//   };


//   const filteredDetails = PayModeData.filter((item) => {
//     if (searchString == null || searchString == '') {
//       return item
//     }

//     else if (String(item[searchElement]).toLowerCase().includes(String(searchString).toLowerCase())) {
//       return item
//     }
//   })


//   const indexOfLastPost = currentPage * postsPerPage
//   const indexOfFirstPost = indexOfLastPost - postsPerPage
//   const currentPosts = DataRow.slice(indexOfFirstPost, indexOfLastPost)

//   const indexOfLastDetPost = detCurrentPage * detPostsPerPage
//   const indexOfFirstDetPost = indexOfLastDetPost - detPostsPerPage
//   const currentDetPosts = filteredDetails.slice(indexOfFirstDetPost, indexOfLastDetPost)


//   return (
//     <React.Fragment>
//       <Row>
//         <Col sm={12} md={12} className="mb-0-sm">
//           <table
//             style={{ fontSize: "12px" }}
//             id={"CashBookPOSTradingDet"}
//           >
//             <thead>
//               <tr>
//                 <th>Payment Mode</th>
//                 <th>Description</th>
//                 <th style={{ textAlign: "right" }}>Amount</th>
//               </tr>
//             </thead>
//             <tbody disabled={true}>

//               {(currentPosts).map((row, key) => (
//                 <TableRow
//                   FormRow={row}
//                   Key={key}
//                   Disabled={Disabled}
//                 />
//               ))}
//             </tbody>

//             <tfoot>

//               <tr>

//                 <th style={{ textAlign: "left" }}>Total Amount</th>
//                 <th ></th>

//                 <th style={{ textAlign: "right" }}>
//                   <DPTextBoxforgrid
//                     rowClass="mb-12-sm"
//                     labelText="Code"
//                     textType="text"
//                     maxLength="8"
//                     textAlign="right"
//                     disabled={true}
//                     defaultValue="0.0"
//                     value={TotalPOSTrandingValue.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}
//                   ></DPTextBoxforgrid>
//                 </th>
//               </tr>
//             </tfoot>
//           </table>
//         </Col>
//       </Row>
//       <Row>
//         <Col sm={6} md={6} className="mb-4-sm">
//           <div className="mt-3 mb-3">
//             <ReactPaginate
//               previousLabel={'Previous'}
//               nextLabel={'Next'}
//               breakLabel={'...'}
//               pageClassName="page-item"
//               pageLinkClassName="page-link"
//               previousClassName="page-item"
//               previousLinkClassName="page-link"
//               nextClassName="page-item"
//               nextLinkClassName="page-link"
//               breakClassName="page-item"
//               breakLinkClassName="page-link"
//               pageCount={Math.ceil(DataRow.length / postsPerPage)}
//               pageRangeDisplayed={5}
//               onPageChange={handlePageClick}
//               forcePage={currentPage - 1}
//               renderOnZeroPageCount={null}
//               activeClassName={'active'}
//               activeLinkClassName={'page-link'}
//               containerClassName={'pagination justify-content-center pagination-sm'}
//             />
//           </div>
//         </Col>
//       </Row>
//       <br />
//       <Row>
//         {PayModeData.length > 0 && (
//           <input
//             id="SearchBar"
//             type="text"
//             className="form-control"
//             value={searchString}
//             placeholder={placeholder}
//             style={{ left: '15px', height: '28px', width: '300px' }}
//             onChange={e => {
//               setSearchString(e.target.value);
//               setCurrentPage(1);
//             }}
//           />
//         )}
//       </Row>
//       <br />
//       <Row>
//         <Col sm={12} md={12} className="mb-4-sm">
//           {PayModeData.length > 0 && (
//             <table style={{ fontSize: "12px" }} id={"detDataTable"}>
//               <thead>
//                 <tr>
//                   <th onClick={e => {
//                     setPlaceholder("Search By POS ID")
//                     setSearchByPosId(true)
//                     setElement("INVPAY_STATION")
//                     setSearchString("")
//                   }} style={{ cursor: 'pointer' }}>POS ID</th>

//                   <th onClick={e => {
//                     setPlaceholder("Search By Bank")
//                     setSearchByBank(true)
//                     setElement("STAT_BANK")
//                     setSearchString("")
//                   }} style={{ cursor: 'pointer' }}>Bank</th>

//                   <th>Machine ID</th>

//                   <th onClick={e => {
//                     setPlaceholder("Search By Mode")
//                     setSearchByMode(true)
//                     setElement("INVPAY_MODE")
//                     setSearchString("")
//                   }} style={{ cursor: 'pointer' }}>Mode</th>

//                   <th>Transaction No</th>

//                   <th>Card No</th>

//                   <th style={{ textAlign: "right" }}>Amount</th>
//                 </tr>
//               </thead>
//               <tbody disabled={true}>

//                 {/* {(filteredDetails).map((dataRow, key) => (
//                 <TableDetRow
//                   FormRow={dataRow}
//                   Key={key}
//                   Disabled={Disabled}
//                   PayModeData={filteredDetails}
//                 />
//               ))} */}

//                 {(currentDetPosts).map((dataRow, key) => (
//                   <TableDetRow
//                     FormRow={dataRow}
//                     Key={key}
//                     Disabled={Disabled}
//                     PayModeData={filteredDetails}
//                   />
//                 ))}

//               </tbody>

//               <tfoot>
//                 <tr>
//                   <th style={{ textAlign: "left" }}>Total Amount</th>
//                   <th ></th>
//                   <th ></th>
//                   <th ></th>
//                   <th ></th>
//                   <th ></th>


//                   <th style={{ textAlign: "right" }}>
//                     <DPTextBoxforgrid
//                       rowClass="mb-12-sm"
//                       labelText="Code"
//                       textType="text"
//                       maxLength="8"
//                       textAlign="right"
//                       disabled={true}
//                       defaultValue="0.0"
//                       value={uniqueTotal}
//                     />
//                   </th>
//                 </tr>
//               </tfoot>
//             </table>
//           )}
//         </Col>
//       </Row>
//       <Row>
//         <Col md="12">
//           <div className="mt-3 mb-3">
//             <ReactPaginate
//               previousLabel={'Previous'}
//               nextLabel={'Next'}
//               breakLabel={'...'}
//               pageClassName="page-item"
//               pageLinkClassName="page-link"
//               previousClassName="page-item"
//               previousLinkClassName="page-link"
//               nextClassName="page-item"
//               nextLinkClassName="page-link"
//               breakClassName="page-item"
//               breakLinkClassName="page-link"
//               pageCount={Math.ceil(filteredDetails.length / detPostsPerPage)}
//               pageRangeDisplayed={5}
//               onPageChange={handleDetPageClick}
//               forcePage={detCurrentPage - 1}
//               renderOnZeroPageCount={null}
//               activeClassName={'active'}
//               activeLinkClassName={'page-link'}
//               containerClassName={'pagination justify-content-center pagination-sm'}
//             />
//           </div>
//         </Col>
//       </Row>
//     </React.Fragment>
//   )
// })

// export default CashBookPOSTrading

// const TableRow = ({ FormRow, Key, Disabled }) => {

//   return (
//     <tr key={FormRow.id}>

//       <td style={{ width: "120px" }}>
//         <Col md="12">
//           <DPTextBoxforgrid
//             rowClass="mb-12-sm"
//             labelText="Code"
//             maxLength="10"
//             textType="text"
//             disabled={true}
//             id={"txtPaymentcode" + Key}
//             value={FormRow.paymentcode}
//           ></DPTextBoxforgrid>
//         </Col>
//       </td>

//       <td style={{ width: "220px" }}>
//         <Col md="12">
//           <DPTextBoxforgrid
//             rowClass="mb-12-sm"
//             labelText="Code"
//             maxLength="10"
//             textType="text"
//             disabled={true}
//             id={"txtPaymentDescription" + Key}
//             value={FormRow.paymentDescription}
//           ></DPTextBoxforgrid>
//         </Col>
//       </td>

//       <td style={{ width: "120px" }}>
//         <Col md="12">
//           <DPTextBoxforgrid
//             rowClass="mb-12-sm"
//             labelText="Code"
//             maxLength="10"
//             defaultValue="0.0"
//             textAlign="right"
//             id={"txtAmount" + Key}
//             value={FormRow.amount}
//             width="70px"
//             disabled={Disabled}
//           ></DPTextBoxforgrid>
//         </Col>
//       </td>

//     </tr>
//   )
// }



// const TableDetRow = ({ FormRow, Key, Disabled }) => {

//   return (
//     <tr key={FormRow.id}>
//       <td style={{ width: "150px" }}>
//         <Col md="12">
//           <DPTextBoxforgrid
//             rowClass="mb-12-sm"
//             labelText="Code"
//             maxLength="10"
//             textType="text"
//             disabled={true}
//             id={"invNo" + Key}
//             value={FormRow.INVPAY_STATION}
//           ></DPTextBoxforgrid>
//         </Col>
//       </td>

//       <td style={{ width: "150px" }}>
//         <Col md="12">
//           <DPTextBoxforgrid
//             rowClass="mb-12-sm"
//             labelText="Code"
//             maxLength="10"
//             textType="text"
//             disabled={true}
//             id={"bank" + Key}
//             value={FormRow.STAT_BANK}
//           ></DPTextBoxforgrid>
//         </Col>
//       </td>

//       <td style={{ width: "160px" }}>
//         <Col md="12">
//           <DPTextBoxforgrid
//             rowClass="mb-12-sm"
//             labelText="Code"
//             maxLength="10"
//             textType="text"
//             disabled={true}
//             id={"machineId" + Key}
//             value={FormRow.STAT_MACHINEID}
//           ></DPTextBoxforgrid>
//         </Col>
//       </td>

//       <td style={{ width: "200px" }}>
//         <Col md="12">
//           <DPTextBoxforgrid
//             rowClass="mb-12-sm"
//             labelText="Code"
//             maxLength="10"
//             textType="text"
//             disabled={true}
//             id={"invMode" + Key}
//             value={FormRow.INVPAY_MODE}
//           ></DPTextBoxforgrid>
//         </Col>
//       </td>

//       <td style={{ width: "200px" }}>
//         <Col md="12">
//           <DPTextBoxforgrid
//             rowClass="mb-12-sm"
//             labelText="Code"
//             maxLength="10"
//             textType="text"
//             disabled={true}
//             id={"invRefNo" + Key}
//             value={FormRow.INVPAY_INVNO}
//           ></DPTextBoxforgrid>
//         </Col>
//       </td>

//       <td style={{ width: "350px" }}>
//         <Col md="12">
//           <DPTextBoxforgrid
//             rowClass="mb-12-sm"
//             labelText="Code"
//             maxLength="10"
//             textType="text"
//             disabled={true}
//             id={"phCode" + Key}
//             value={FormRow.INVPAY_REFNO}
//           ></DPTextBoxforgrid>
//         </Col>
//       </td>

//       <td style={{ width: "200px" }}>
//         <Col md="12">
//           <DPTextBoxforgrid
//             rowClass="mb-12-sm"
//             labelText="Code"
//             maxLength="10"
//             defaultValue="0.0"
//             textAlign="right"
//             id={"invAmount" + Key}
//             value={FormRow.INVPAY_AMOUNT}
//             width="70px"
//             disabled={Disabled}
//           ></DPTextBoxforgrid>
//         </Col>
//       </td>

//     </tr>
//   )
// }




import React, { useState, useEffect, useMemo } from "react";
import { Row, Col, Button } from "reactstrap";
import DPTextBoxforgrid from "../../../framework/components/DPTextBoxforgrid";
import ReactPaginate from "react-paginate";
import DPSwitch from "framework/components/DPSwitch"


const CashBookPOSTrading = React.memo(({ DataRow, Disabled, TotalPOSTrandingValue,
  handleClear, PayModeData, setrowsPOSTranding,
  setPayModeData, csbList, cashBookType, paymentCode, setrowsSummary, rowsSummary }) => {

  const [detPostsPerPage] = useState(10);
  const [detCurrentPage, setDetCurrentPage] = useState(1);
  const [selectedFormula, setSelectedFormula] = useState("=")


  const [posid, setPosid] = useState("");
  const [bank, setBank] = useState("");
  const [machineID, setMachineID] = useState("");
  const [mode, setMode] = useState("");
  const [systemNo, setSystemNo] = useState("");
  const [cardRefNo, setCardRefNo] = useState("");
  const [cardNo, setCardNo] = useState("");
  const [amount, setAmount] = useState("");



  const filterbyPOSID = PayModeData.filter((item) => {
    if (posid == "") return item;
    if (String(item.INVPAY_STATION).toLowerCase().includes(String(posid).toLowerCase()))
      return item;
  })

  const filterbyBank = filterbyPOSID.filter((item) => {

    if (bank == "") return item;

    if (String(item.STAT_BANK).toLowerCase().includes(String(bank).toLowerCase()))
      return item;
  })

  const filterbyMachineID = filterbyBank.filter((item) => {

    if (machineID == "") return item;
    if (String(item.STAT_MACHINEID).toLowerCase().includes(String(machineID).toLowerCase()))
      return item
  })

  const filterbyMode = filterbyMachineID.filter((item) => {

    if (mode == "") return item;
    if (String(item.INVPAY_MODE).toLowerCase().includes(String(mode).toLowerCase()))
      return item
  })

  const filterbySystemNo = filterbyMode.filter((item) => {

    if (systemNo == "") return item;
    if (String(item.INVPAY_INVNO).toLowerCase().includes(String(systemNo).toLowerCase()))
      return item
  })

  const filterbyCardRefNo = filterbySystemNo.filter((item) => {

    if (cardRefNo == "") return item;
    if (String(item.INVPAY_CARDREFNO).toLowerCase().includes(String(cardRefNo).toLowerCase()))
      return item
  })

  const filterbyCardNo = filterbyCardRefNo.filter((item) => {

    if (cardNo == "") return item;
    if (String(item.INVPAY_REFNO).toLowerCase().includes(String(cardNo).toLowerCase()))
      return item
  })

  const filterbyAmount = filterbyCardNo.filter((item) => {

    if (amount == "") return item;

    if (selectedFormula === "=") {
      if (parseFloat(item.INVPAY_AMOUNT) === parseFloat(amount)) return item
    }

    if (selectedFormula === ">") {
      if (parseFloat(item.INVPAY_AMOUNT) > parseFloat(amount)) return item
    }

    if (selectedFormula === "<") {
      if (parseFloat(item.INVPAY_AMOUNT) < parseFloat(amount)) return item
    }


  })




  useEffect(() => {
    setDetCurrentPage(1);
    setPosid("");
    setBank("");
    setMachineID("");
    setMode("");
    setSystemNo("");
    setCardRefNo("");
    setCardNo("");
    setAmount("");


  }, [handleClear, paymentCode]);


  const handleDetPageClick = (event) => {
    setDetCurrentPage(event.selected + 1);
  };


  const changeRowValueChanges = async (value, id, element) => {

    const updatedDataRow = PayModeData.map(obj => {
      if (obj.id === id) {
        return { ...obj, [element]: value };
      }
      return obj;
    });

    const isAllTrue = updatedDataRow.every((item) => item.state === true);

    if (isAllTrue) {
      updateSelectedPaymodeStatus(true)
    } else {
      updateSelectedPaymodeStatus(false)
    }

    setPayModeData(updatedDataRow);

  };



  function enableAlltheFields() {

    const isAllEnabled = PayModeData.every((item) => item.state === true);

    const updatedDataRow = PayModeData.map(obj => {
      return { ...obj, state: !isAllEnabled };
    }
    );

    if (!isAllEnabled) {
      updateSelectedPaymodeStatus(true)
    } else {
      updateSelectedPaymodeStatus(false)
    }

    setPayModeData(updatedDataRow);

  }


  const indexOfLastDetPost = detCurrentPage * detPostsPerPage;
  const indexOfFirstDetPost = indexOfLastDetPost - detPostsPerPage;
  const currentDetPosts = filterbyAmount.slice(indexOfFirstDetPost, indexOfLastDetPost);

  const selectedValue = csbList.find((item) => item.value === cashBookType);


  function updateSelectedPaymodeStatus(state) {

    const updatedSummaryRow = rowsSummary.map(obj => {
      if (obj.paymentcode == paymentCode) {
        return { ...obj, state: state };
      }
      return obj;
    })

    setrowsSummary(updatedSummaryRow);

  }



  return (
    <React.Fragment>
      <Row className="my-2">
        {selectedValue && selectedValue.label ? selectedValue.label : ""}
      </Row>
      <Row className="my-2">
        {paymentCode}
      </Row>
      <Row>
        <Col sm={12} md={12} className="mb-4-sm">
          {PayModeData.length > 0 && (
            <table style={{ fontSize: "12px" }} id={"detDataTable"}>
              <thead>
                <tr>
                  <th>#</th>
                  <th>POS ID</th>
                  <th>Bank</th>
                  <th>Machine ID</th>
                  <th>Mode</th>
                  <th>System No</th>
                  <th>Card Ref No</th>
                  <th>Card No</th>
                  <th style={{ textAlign: "right" }}>Amount</th>
                  <th style={{ textAlign: "left", cursor: "pointer" }} onClick={enableAlltheFields}>Checked</th>
                </tr>
                <tr>
                  <th></th>
                  <th>
                    <DPTextBoxforgrid
                      rowClass="mb-12-sm"
                      labelText="Code"
                      maxLength="10"
                      textType="text"
                      value={posid}
                      onChange={(e) => {
                        setPosid(e.target.value)
                        setDetCurrentPage(1)
                      }}
                    />
                  </th>
                  <th>
                    <DPTextBoxforgrid
                      rowClass="mb-12-sm"
                      labelText="Code"
                      maxLength="100"
                      textType="text"
                      value={bank}
                      onChange={(e) => {
                        setBank(e.target.value)
                        setDetCurrentPage(1)
                      }}
                    />
                  </th>
                  <th>
                    <DPTextBoxforgrid
                      rowClass="mb-12-sm"
                      labelText="Code"
                      maxLength="100"
                      textType="text"
                      value={machineID}
                      onChange={(e) => {
                        setMachineID(e.target.value)
                        setDetCurrentPage(1)
                      }}
                    /></th>
                  <th>
                    <DPTextBoxforgrid
                      rowClass="mb-12-sm"
                      labelText="Code"
                      maxLength="100"
                      textType="text"
                      value={mode}
                      onChange={(e) => {
                        setMode(e.target.value)
                        setDetCurrentPage(1)
                      }}
                    /></th>
                  <th>
                    <DPTextBoxforgrid
                      rowClass="mb-12-sm"
                      labelText="Code"
                      maxLength="100"
                      textType="text"
                      value={systemNo}
                      onChange={(e) => {
                        setSystemNo(e.target.value)
                        setDetCurrentPage(1)
                      }}
                    /></th>
                  <th>
                    <DPTextBoxforgrid
                      rowClass="mb-12-sm"
                      labelText="Code"
                      maxLength="100"
                      textType="text"
                      value={cardRefNo}
                      onChange={(e) => {
                        setCardRefNo(e.target.value)
                        setDetCurrentPage(1)
                      }}
                    /></th>
                  <th>
                    <DPTextBoxforgrid
                      rowClass="mb-12-sm"
                      labelText="Code"
                      maxLength="100"
                      textType="text"
                      value={cardNo}
                      onChange={(e) => {
                        setCardNo(e.target.value)
                        setDetCurrentPage(1)
                      }}
                    /></th>
                  <th>
                    <DPTextBoxforgrid
                      rowClass="mb-12-sm"
                      labelText="Code"
                      maxLength="20"
                      textType="text"
                      textAlign={"right"}
                      value={amount}
                      onChange={(e) => {
                        setAmount(e.target.value)
                        setDetCurrentPage(1)
                      }}
                    /></th>
                  <th>
                  </th>
                </tr>
                <tr>
                  <td colSpan={8}>
                  </td>
                  <td colSpan={2} className="flex" >
                    <Button className="mx-1" color={selectedFormula === "=" ? 'primary' : "secondary"} size="sm" onClick={() => setSelectedFormula("=")}>=</Button>
                    <Button className="mx-1" color={selectedFormula === ">" ? 'primary' : "secondary"} size="sm" onClick={() => setSelectedFormula(">")}>{">"}</Button>
                    <Button className="mx-1" color={selectedFormula === "<" ? 'primary' : "secondary"} size="sm" onClick={() => setSelectedFormula("<")}>{"<"}</Button>
                  </td>
                </tr>
              </thead>
              <tbody disabled={true}>
                {currentDetPosts.map((dataRow, key) => (
                  <TableDetRow
                    FormRow={dataRow}
                    Key={key}
                    Disabled={Disabled}
                    changeRowValueChanges={changeRowValueChanges}
                    indexOfFirstDetPost={indexOfFirstDetPost}
                  />
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <th></th>
                  <th style={{ textAlign: "left" }}>Total Amount</th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th style={{ textAlign: "right" }}>
                    <DPTextBoxforgrid
                      rowClass="mb-12-sm"
                      labelText="Code"
                      textType="text"
                      maxLength="8"
                      textAlign="right"
                      disabled={true}
                      defaultValue="0.0"
                      value={parseFloat(filterbyAmount.reduce((a, b) => a + (parseFloat(b.INVPAY_AMOUNT ?? 0)), 0)).toFixed(2)}
                    />
                  </th>
                </tr>
              </tfoot>
            </table>
          )}
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <div className="mt-3 mb-3">
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              breakLabel={"..."}
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakClassName="page-item"
              breakLinkClassName="page-link"
              pageCount={Math.ceil(filterbyAmount.length / detPostsPerPage)}
              pageRangeDisplayed={5}
              onPageChange={handleDetPageClick}
              forcePage={detCurrentPage - 1}
              renderOnZeroPageCount={null}
              activeClassName={"active"}
              activeLinkClassName={"page-link"}
              containerClassName={"pagination justify-content-center pagination-sm"}
            />
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
});

export default CashBookPOSTrading;


const TableDetRow = ({ FormRow, Key, Disabled, changeRowValueChanges, indexOfFirstDetPost }) => {
  return (
    <tr key={FormRow.id}>
      <td>{indexOfFirstDetPost + Key + 1}</td>
      <td style={{ width: "100px" }}>
        <Col md="12">
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            textType="text"
            disabled={true}
            id={"invNo" + Key}
            value={FormRow.INVPAY_STATION}
          />
        </Col>
      </td>
      <td style={{ width: "150px" }}>
        <Col md="12">
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            textType="text"
            disabled={true}
            id={"bank" + Key}
            value={FormRow.STAT_BANK}
          />
        </Col>
      </td>
      <td style={{ width: "160px" }}>
        <Col md="12">
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            textType="text"
            disabled={true}
            id={"machineId" + Key}
            value={FormRow.STAT_MACHINEID}
          />
        </Col>
      </td>
      <td style={{ width: "100px" }}>
        <Col md="12">
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            textType="text"
            disabled={true}
            id={"invMode" + Key}
            value={FormRow.INVPAY_MODE}
          />
        </Col>
      </td>
      <td style={{ width: "200px" }}>
        <Col md="12">
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            textType="text"
            disabled={true}
            id={"invRefNo" + Key}
            value={FormRow.INVPAY_INVNO}
          />
        </Col>
      </td>
      <td style={{ width: "200px" }}>
        <Col md="12">
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            textType="text"
            disabled={true}
            id={"invRefNo" + Key}
            value={FormRow.INVPAY_INVNO}
          />
        </Col>
      </td>
      <td style={{ width: "300px" }}>
        <Col md="12">
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            textType="text"
            disabled={true}
            id={"phCode" + Key}
            value={FormRow.INVPAY_REFNO}
          />
        </Col>
      </td>
      <td style={{ width: "150px" }}>
        <Col md="12">
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            defaultValue="0.0"
            textAlign="right"
            id={"invAmount" + Key}
            value={parseFloat(FormRow.INVPAY_AMOUNT ?? 0).toFixed(2)}
            width="70px"
            disabled={Disabled}
          />
        </Col>
      </td>

      <td style={{ width: "350px" }}>
        <Col md="12">
          <DPSwitch

            rowClass={"mb-4-sm"}
            height={23}
            handleDiameter={15}
            onChange={(e) => {
              changeRowValueChanges(e, FormRow.id, "state")
            }}
            checked={FormRow.state}
            id={"swInvActive" + Key}
            disabled={false}
          />
        </Col>
      </td>
    </tr>
  );
};